import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SignupService} from "../../services/signup.service";

@Component({
  selector: 'app-merchant-signup',
  templateUrl: './merchant-signup.component.html',
  styleUrls: ['./merchant-signup.component.css']
})
export class MerchantSignupComponent implements OnInit {

  public signUpForm: FormGroup;

  constructor(private formBuilder: FormBuilder, protected signupService: SignupService) {  }

  ngOnInit() {
    this.signUpForm = this.formBuilder.group({
      basicInfo: {
        name: ['', [Validators.required, Validators.maxLength(256)]],
        businessName: ['', [Validators.required, Validators.maxLength(256)]],
        email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]],
        password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
      },
      merchantInfo: null,
      contactInfo: null
    });

    // this.subscriptionForm = this.formBuilder.group({
    //   email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]]
    // });
  }

  // subformInitialized(name: string, group: FormGroup) {
  //   this.signUpForm.setControl(name, group);
  // }

  openMobileVerificationModalButtonClicked() {
    // $('#my-modal').modal('show');
  }



}


